/* ZUCK-RAFFLE 2026-11-03 — sorteio do iPhone: popup, botao flutuante (posicao + balanco).
   Markup: snippets/zuck-raffle-body.liquid. Qualquer [data-zrf-open] abre o popup; [data-zrf-close] fecha. */
(function () {
  if (window.__zrf) return;
  window.__zrf = 1;
  var overlay = document.getElementById('zrf-overlay');
  if (!overlay) return;
  var panel = document.getElementById('zrf-dialog');
  var fab = document.getElementById('zrf-fab');
  var root = document.documentElement;
  var still = window.matchMedia('(prefers-reduced-motion: reduce)');
  var SEEN = 'zrf_seen';
  var seen = false;
  try { seen = sessionStorage.getItem(SEEN) === '1'; } catch (e) {}
  if (seen && fab) fab.classList.add('is-seen');
  var last = null;

  function focusables() {
    return Array.prototype.filter.call(panel.querySelectorAll('button, a[href], [tabindex]:not([tabindex="-1"])'), function (el) {
      return el.offsetParent !== null;
    });
  }
  function open(trigger) {
    if (!overlay.hidden) return;
    last = trigger || document.activeElement;
    overlay.hidden = false;
    root.classList.add('zrf-lock');
    requestAnimationFrame(function () { requestAnimationFrame(function () { overlay.classList.add('is-open'); }); });
    panel.focus({ preventScroll: true });
    seen = true;
    try { sessionStorage.setItem(SEEN, '1'); } catch (e) {}
    if (fab) fab.classList.add('is-seen');
  }
  function close() {
    if (overlay.hidden) return;
    overlay.classList.remove('is-open');
    root.classList.remove('zrf-lock');
    setTimeout(function () { if (!overlay.classList.contains('is-open')) overlay.hidden = true; }, still.matches ? 0 : 230);
    if (last && last.isConnected && last.focus) last.focus({ preventScroll: true });
  }
  window.zuckRaffle = { open: open, close: close };

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-zrf-open]');
    if (t) { e.preventDefault(); open(t); return; }
    if (e.target.closest && e.target.closest('[data-zrf-close]')) { close(); return; }
    if (e.target === overlay) close();
  });
  document.addEventListener('keydown', function (e) {
    if (overlay.hidden) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) return;
    var a = f[0], z = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === a || document.activeElement === panel)) { e.preventDefault(); z.focus(); }
    else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
  });

  if (!fab) return;

  /* Posicao: fica acima do que o tema prende embaixo neste lado (WhatsApp, dock, botao do Gifter, pilula de compra,
     cartao da Black...). Sonda os cantos do botao e sobe acima do elemento fixo encontrado (repete: eles empilham). */
  var M = 12;
  function obstacleRect(el) {
    var best = null;
    for (var n = el; n && n !== document.body && n !== root; n = n.parentElement) {
      if (fab.contains(n) || n === fab.parentElement) return null;
      var r = n.getBoundingClientRect();
      if (r.height < innerHeight / 2 && r.width > 0) best = r;
      if (getComputedStyle(n).position === 'fixed') return best;
    }
    return null;
  }
  function place() {
    if (!overlay.hidden) return;
    // Measure with the transition OFF: with `transition: bottom` on, getBoundingClientRect returns the animated
    // (old) spot right after a change, so the probe looked at the wrong place and the button bounced up and down.
    var prev = fab.style.bottom;
    fab.style.transition = 'none';
    fab.style.bottom = '';
    var next = '';
    for (var k = 0; k < 5; k++) {
      var r = fab.getBoundingClientRect();
      var top = Infinity;
      // 3x3 grid, not just the corners: hit testing follows border-radius, so two round buttons can overlap
      // without any corner of one landing inside the other (the WhatsApp circle did exactly that).
      var pts = [];
      [r.left + 3, r.left + r.width / 2, r.right - 3].forEach(function (x) {
        [r.top + 3, r.top + r.height / 2, r.bottom - 3].forEach(function (y) { pts.push([x, y]); });
      });
      pts.forEach(function (p) {
        document.elementsFromPoint(p[0], p[1]).forEach(function (el) {
          var o = obstacleRect(el);
          // only things pinned to the lower part count (a newsletter modal or the header must not stop the lift)
          if (o && o.top >= innerHeight / 3) top = Math.min(top, o.top);
        });
      });
      if (top === Infinity) break;
      next = Math.round(innerHeight - top + M) + 'px';
      fab.style.bottom = next;
    }
    // back to where it was, then let the transition carry it to the new spot
    fab.style.bottom = prev;
    void fab.offsetHeight;
    fab.style.transition = '';
    if (next !== prev) fab.style.bottom = next;
  }
  var raf = 0, settle = 0;
  // place now, and again once neighbours finish their own move (WhatsApp eases its bottom over 180 ms on scroll)
  function later() {
    if (!raf) raf = requestAnimationFrame(function () { raf = 0; place(); });
    clearTimeout(settle);
    settle = setTimeout(place, 320);
  }
  addEventListener('resize', later);
  addEventListener('scroll', later, { passive: true });
  addEventListener('load', later);
  setInterval(function () { if (!document.hidden) place(); }, 1500);
  /* Home: enquanto o selo do banner esta na tela, o botao some (mesma acao; no celular os dois caiam um sobre o outro
     no canto de baixo do banner). Rolou alem do banner: o botao volta. */
  var seal = document.getElementById('zrf-seal');
  if (seal && !seal.hidden && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) {
      fab.parentElement.classList.toggle('is-yield', en[0].isIntersecting);
    }, { threshold: 0.25 }).observe(seal);
  }

  place();
  // the dock, WhatsApp and the BF card settle in the first seconds: re-place a few times early
  [250, 700, 1200, 2000, 3000].forEach(function (t) { setTimeout(place, t); });

  /* Balanco (mesmo ritmo do botao de brindes do Gifter): um "vibrar" de celular a cada 5 s, o primeiro 1,5 s depois
     de aparecer. Para quando a cliente ja abriu o popup nesta sessao; nunca com reduzir movimento. */
  if (fab.getAttribute('data-zrf-shake') !== '1' || !fab.animate) return;
  var SHAKE = [
    { transform: 'rotate(0deg) scale(1)' },
    { transform: 'rotate(-14deg) scale(1.08)', offset: 0.12 },
    { transform: 'rotate(12deg) scale(1.08)', offset: 0.26 },
    { transform: 'rotate(-10deg) scale(1.06)', offset: 0.4 },
    { transform: 'rotate(8deg) scale(1.04)', offset: 0.54 },
    { transform: 'rotate(-4deg) scale(1.02)', offset: 0.7 },
    { transform: 'rotate(0deg) scale(1)' }
  ];
  function shake() {
    if (seen || still.matches || !overlay.hidden || document.hidden || !fab.offsetParent) return;
    fab.animate(SHAKE, { duration: 750, easing: 'ease-in-out', composite: 'add' });
  }
  setTimeout(function () { shake(); setInterval(shake, 5000); }, 1500);
})();
